import React from "react";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { MediaItemCreateScreen } from "./MediaItemCreateScreen";

export const ResourceCreateScreen: React.FC<any> = observer((props) => {
  const { courseId } = useParams();
  return <MediaItemCreateScreen subjectId={courseId} />;
});
